/**
 * Collection of utilities for interacting with browser APIs since these
 * are only safe in a browser environment
 */

const safeWindow = typeof window !== 'undefined' ? window : null

const safeDocument = safeWindow?.document

/**
 * Root Element where JSX is rendered. Useful for mounting portals
 */
export const getRootElement = () => safeDocument?.getElementById('__next')

export { safeWindow as window, safeDocument as document }
